import React from "react";
import * as R from "ramda";
import { Link } from "react-router-dom";

import { useProject } from "queries/projects";
import { getRequirementApplication, getStatus } from "reducers/projects";
import { getApplicationAdminURL, getApplicationURL } from "selectors/routes";

const applicationIsLinkable = (application) => {
  const status = getStatus(application);
  return status !== "in_progress";
};

export const ApplicationLink = ({ application, requirementName, applicantContext }) => {
  if (!application || !applicationIsLinkable(application)) return requirementName;
  const url = applicantContext
    ? getApplicationURL(application)
    : getApplicationAdminURL(application);

  return <Link to={url}>{requirementName}</Link>;
};

const MaybeApplicationLinkFromEvent = ({ event, applicantContext = false }) => {
  const applicationID = R.prop("requirement_application_id", event);
  const projectID = R.prop("project_id", event);
  const requirementName = R.path(["payload", "data", "requirement_name"], event);

  const { data: project, isLoading } = useProject(projectID);
  if (isLoading) return null;

  const application = getRequirementApplication(project, applicationID);

  return (
    <ApplicationLink
      application={application}
      requirementName={requirementName}
      applicantContext={applicantContext}
    />
  );
};

export default MaybeApplicationLinkFromEvent;
